<div
  class="form-group mb-0"
  *ngIf="{
    isPremium: isPremium$ | async
  } as p"
>
  <div
    class="btn-group position-relative"
    dropdown
    #dropdown="bs-dropdown"
    [autoClose]="true"
    [insideClick]="true"
    [isDisabled]="!p.isPremium"
  >
    <button
      dropdownToggle
      class="btn btn-sm btn-outline-secondary dropdown-toggle"
      gtagEvent
      trackOn="click"
      action="Arrive/Depart_Panel"
      category="Route"
      [params]="{ event_label: 'Arrive/Depart clicked' }"
    >
      Arrive/Depart
    </button>
    <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
      <form class="px-2">
        <!-- Radio buttons -->
        <div class="form-group">
          <h6>Select a Departure or Arrival Date/Time</h6>
          <div
            class="custom-control custom-radio"
            *ngFor="let adRadio of optionsUI.arrDepTypes; let adIndex = index"
          >
            <input
              type="radio"
              class="custom-control-input"
              id="ArrDepRadio{{ adIndex }}"
              name="ArrDepRadio"
              value="{{ adRadio.value }}"
              [(ngModel)]="type"
              (change)="onTypeChange(adRadio.value)"
              ngDefaultControl
            />
            <label
              class="custom-control-label"
              for="ArrDepRadio{{ adIndex }}"
              >{{ adRadio.display }}</label
            >
          </div>
        </div>
        <!-- Date picker and time field -->
        <div class="form-group">
          <!-- dropdown width setting? -->
          <div class="d-flex" style="width: 280px">
            <input
              type="text"
              class="form-control"
              #dp="bsDatepicker"
              bsDatepicker
              [disabled]="datepickerDisabled"
              [(ngModel)]="date"
              name="datepicker1"
              [bsConfig]="{ showWeekNumbers: false }"
            />
            <button
              class="btn btn-text-dark btn-icon-only mr-1"
              (click)="dp.toggle()"
              [attr.aria-expanded]="dp.isOpen"
              [disabled]="datepickerDisabled"
              type="button"
            >
              <i class="modus-icons">calendar</i>
            </button>
            <div [formGroup]="timeGroup" style="width: 100%">
              <app-time-field
                formControlName="timeControl"
                [disabled]="datepickerDisabled"
              ></app-time-field>
            </div>
          </div>
        </div>
        <!-- Apply Traffic -->
        <div class="">
          <div class="dropdown-divider"></div>
          <div class="custom-control custom-switch custom-control-inline mr-4">
            <input
              type="checkbox"
              [checked]="applyTraffic"
              class="custom-control-input"
              id="applyTraffic"
              [disabled]="trafficDisabled"
              (change)="toggleTraffic($event)"
            />
            <label class="custom-control-label" for="applyTraffic">
              Apply Traffic
            </label>
          </div>
        </div>
        <!-- Buttons Cancel, Set-->
        <div class="">
          <div class="dropdown-divider"></div>
          <div class="d-flex justify-content-end">
            <button
              class="btn btn-sm btn-outline-dark ml-1"
              (click)="dropdown.hide()"
            >
              Cancel
            </button>
            <button
              class="btn btn-sm btn-primary ml-1"
              (click)="dropdown.hide(); setArriveDepart()"
              [disabled]="!datepickerDisabled && timeGroup.invalid"
            >
              Set
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
